export function TabLabel({
  label,
  total,
  isLoading,
}: {
  label: string;
  total: number;
  isLoading: boolean;
}) {
  return (
    <span>
      {label}{' '}
      <span className="text-xs opacity-70">
        ({isLoading ? '···' : total.toLocaleString('pt-BR')})
      </span>
    </span>
  );
}
